var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"Hoarding",on:{"click":_vm.hide}},[_c('img',{staticClass:"tool-icon",attrs:{"src":_vm.isGather
        ? require('@/assets/img/mobile-img/iscollect-icon.png')
        : require('@/assets/img/mobile-img/collect-icon.png'),"alt":""}}),_c('span',[_vm._v("收藏")])]),(_vm.toast !== '')?_c('div',{staticClass:"toast"},[_c('span',[_vm._v(_vm._s(_vm.toast))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }